import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Tab, Tabs } from "react-tabs-scrollable";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import { styles } from "../pages/styles";
import "../App.css";
import { colors } from "../common/colors";
import { Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import BackHandIcon from "@mui/icons-material/BackHandOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColorOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircleOutlined";
import Search from "@mui/icons-material/Search";
export default function Header() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<number>(0);
  const { user } = useSelector((state: any) => state.userAuth);
  useEffect(() => {
    if (user?.id) {
      // pass
    }
  }, [user, location]);

  const onTabClick = (e: any, index: number) => {
    setActiveTab(index);
  };
  useEffect(() => {
    if (location.pathname === "/home") {
      setActiveTab(0);
    } else if (location.pathname === "/facilitator") {
      setActiveTab(1);
    } else if (location.pathname === "/categories") {
      setActiveTab(2);
    } else if (location.pathname === "/myfarm") {
      setActiveTab(3);
    } else if (location.pathname === "/search") {
      setActiveTab(4);
    }
  }, [location.pathname]);
  return (
    <div>
      {location.pathname === "/home" ||
      location.pathname === "/categories" ||
      location.pathname === "/facilitator" ||
      location.pathname === "/suggestion" ||
      location.pathname === "/dashboard" ||
      location.pathname === "/myfarm" ||
      location.pathname === "/votingseemore" ||
      location.pathname === "/detailsview" ||
      location.pathname === "/posthistory" ||
      location.pathname === "/search" ||
      location.pathname === "/everyoneshistory" ||
      location.pathname === "/commenthistory" ||
      location.pathname === "/creategroupstep1" ||
      location.pathname === "/creategroupsteptwo" ||
      location.pathname === "/groupinforeview" ||
      location.pathname === "/disclosure" ||
      location.pathname === "/steppii" ||
      location.pathname === "/groupleader" ||
      location.pathname === "/viewGroupPost" ||
      location.pathname === "/groupeventsetting" ||
      location.pathname === "/memberlist" ||
      location.pathname === "/members" ||
      location.pathname === "/approved_member_list" ||
      location.pathname === "/userchat" ||
      location.pathname === "/group_chat_list" ||
      location.pathname === "/calenderevent" ||
      location.pathname === "/chat" ||
      location.pathname === "/grouppayment" ||
      location.pathname === "/memberPaymentStatus" ||
      location.pathname === "/eventapplicationpayment" ||
      location.pathname === "/groupeventscalendar" ||
      location.pathname === "/usereventcancellation" ||
      location.pathname === "/refundeventfee" ||
      location.pathname === '/groupcancelmembership' ||
      location.pathname === '/groupclosedetails' ||
      location.pathname === "/grouproles" ||
      location.pathname === "/cancelrequests" ||
      location.pathname === "/eventusers" ||
      location.pathname === "/invitation" ||
      location.pathname === "/groupinvitation" ||
      location.pathname === "/leadercancellation" ||
      location.pathname === "/userchatlist" ||
      location.pathname === "/paytostoreqr" ||
      location.pathname === "/paytouser" ||
      location.pathname === "/paymentreimbursement" ||
      location.pathname === "/eventpostdetails" ||
      location.pathname === "/usereventpaymentdetail" ||
      location.pathname === "/eventcanceldetails" ||
      location.pathname === "/reimbursements" ||
      location.pathname === "/groupreimbursements" ||
      location.pathname === "/paymenthistory" ||
      location.pathname === "/createleadereventpost" ||
      location.pathname === "/viewpostuser" ||
      location.pathname === "/addpostuser" ||
      location.pathname === "/paymentInfo" ||
      location.pathname === "/paymentreview" ||
      location.pathname === "/rejectreimbursement" ||
      location.pathname === "/scangroupqr" ||
      location.pathname === "/post_report" ||
      location.pathname === "/chat_users" ||
      location.pathname === "/createPost" ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            height: 76,
            backgroundColor: "white",
            zIndex: 9,
            width: "100%",
          }}
        >
          <Tabs hideNavBtns hideNavBtnsOnMobile={true} tabsContainerStyle={styles.tabContainer} activeTab={activeTab} onTabClick={onTabClick}>
            <Tab style={activeTab === 0 ? { ...styles.activeTab, borderLeftWidth: 0, minWidth: 50 } : { ...styles.unActiveTab, borderLeftWidth: 0, minWidth: 50 }} key={"1"}>
              <div
                style={{
                  height: 6,
                  marginBottom: 4,
                  backgroundColor: activeTab === 0 ? colors.farm_green500 : "#FFFFFF",
                }}
              ></div>
              <Link id="GFG" to="/home">
                <HomeIcon
                  style={{
                    color: activeTab === 0 ? colors.farm_green500 : "#000000",
                  }}
                />
                {/* {activeTab === 0 ? (
                ) : (
                 <HomeIcon/>
                )} */}
                <Typography style={styles.tabTitle}>{T("home")}</Typography>
              </Link>
            </Tab>

            <Tab style={activeTab === 1 ? { ...styles.activeTab, minWidth: 80 } : { ...styles.unActiveTab, minWidth: 80 }} key={"3"}>
              <div
                style={{
                  height: 6,
                  marginBottom: 4,
                  backgroundColor: activeTab === 1 ? colors.farm_green500 : "#FFFFFF",
                }}
              ></div>
              <Link id="GFG" to="/facilitator">
                <BackHandIcon
                  style={{
                    color: activeTab === 1 ? colors.farm_green500 : "#000000",
                  }}
                />

                <Typography style={styles.tabTitle}>{T("opinion_plaza")}</Typography>
              </Link>
            </Tab>
            <Tab style={activeTab === 2 ? { ...styles.activeTab, minWidth: 80 } : { ...styles.unActiveTab, minWidth: 80 }} key={"2"}>
              <div
                style={{
                  height: 6,
                  marginBottom: 4,
                  backgroundColor: activeTab === 2 ? colors.farm_green500 : "#FFFFFF",
                }}
              ></div>
              <Link id="GFG" to="/categories">
                <BorderColorIcon
                  style={{
                    color: activeTab === 2 ? colors.farm_green500 : "#000000",
                  }}
                />

                <Typography style={styles.tabTitle}>{T("everyone_post")}</Typography>
              </Link>
            </Tab>

            <Tab style={activeTab === 3 ? { ...styles.activeTab, minWidth: 80 } : { ...styles.unActiveTab, minWidth: 80 }} key={"4"}>
              <div
                style={{
                  height: 6,
                  marginBottom: 4,
                  backgroundColor: activeTab === 3 ? colors.farm_green500 : "#FFFFFF",
                }}
              ></div>
              <Link id="GFG" to="/myfarm">
                <AccountCircleIcon
                  style={{
                    color: activeTab === 3 ? colors.farm_green500 : "#000000",
                  }}
                />

                <Typography style={styles.tabTitle}>{T("mypage")}</Typography>
              </Link>
            </Tab>

            <Tab style={activeTab === 4 ? { ...styles.activeTab, minWidth: 65 } : { ...styles.unActiveTab, minWidth: 65 }} key={"5"}>
              <div
                style={{
                  height: 6,
                  marginBottom: 4,
                  backgroundColor: activeTab === 4 ? colors.farm_green500 : "#FFFFFF",
                }}
              ></div>
              <Link id="GFG" to="/search">
                <Search
                  style={{
                    color: activeTab === 4 ? colors.farm_green500 : "#000000",
                  }}
                />

                <Typography style={styles.tabTitle}>{T("search")}</Typography>
              </Link>
            </Tab>
          </Tabs>
        </div>
      ) : null}
    </div>
  );
}
